// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

const VOUCHER_DETAILS_START_LOADER = 'VOUCHER_DETAILS_START_LOADER';
const VOUCHER_DETAILS_STOP_LOADER = 'VOUCHER_DETAILS_STOP_LOADER';

const VOUCHER_DETAILS_GET_VOUCHER = 'VOUCHER_DETAILS_GET_VOUCHER';
const VOUCHER_DETAILS_GET_VOUCHER_SUCCESS = 'VOUCHER_DETAILS_GET_VOUCHER_SUCCESS';


export {
  VOUCHER_DETAILS_START_LOADER,
  VOUCHER_DETAILS_STOP_LOADER,

  VOUCHER_DETAILS_GET_VOUCHER,
  VOUCHER_DETAILS_GET_VOUCHER_SUCCESS,
};
